export const minBarHeight = 48;

// schedule
export const scheduleWidth = 38;
export const schedulePadding = 2;
export const minScheduleWidth = 480;

// axis
export const axisPadding = 8;
export const axisHeight = 24;
export const minAxisHeight = minBarHeight + axisPadding + axisHeight;
